import { renderMarkdown } from '@a2ui/markdown-it';
import { useEffect, useState } from 'react';

import { MarkdownContent } from './DeepSearchPage.styles';

interface MarkdownMessageProps {
  content: string;
}

export const MarkdownMessage = ({ content }: MarkdownMessageProps) => {
  // null = markdown not rendered yet (pending or failed); we fall back to the
  // raw text so the assistant response is never dropped.
  const [html, setHtml] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    renderMarkdown(content)
      .then((rendered) => {
        if (!cancelled) {
          setHtml(rendered);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setHtml(null);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [content]);

  if (html === null) {
    return (
      <MarkdownContent sx={{ whiteSpace: 'pre-wrap' }}>
        {content}
      </MarkdownContent>
    );
  }

  return <MarkdownContent dangerouslySetInnerHTML={{ __html: html }} />;
};
